export const initialCompanyData = {
  formone: {
    legalName: '',
    shortName: '',
    companyEmail: '',
    mobile: '',
    country: 'IndiaState',
    pincode: '',
    states: '',
    district: '',
    city: '',
    website: '',
    currency: '1',
    buisnessType: [],
    industryType: [],
    companyLogo: '',
    buisnessAddress: '',
    status: false,
    errorStatus: {
      businessName: false,
      legalName: false,
      website: false,
      companyEmail: false,
      mobile: false,
      country: false,
      pincode: false,
      states: false,
      district: false,
      shortName: false,
      currency: false,
    },
    errorFields: {
      businessName: '',
      legalName: '',
      companyEmail: '',
      mobile: '',
      website: '',
      country: '',
      pincode: '',
      states: '',
      district: '',
      currency: '',
    },
  },
  formtwo: {
    registrationType: '',
    gstin: '',
    gstApplicableDate: '',
    gstReturnPeriod: '',
    eWayBill: 0,
    ewayBillStartDate: '',
    eWayBillInterStateAmount: '',
    eWayBillIntraStateAmount: '',
    eInvoicing: 0,
    eInvoiceStartDate: '',
    gstCessFlag: 0,
    CompositionRates: '',
    lutBondNo: '',
    lutValidFrom: '',
    lutValidTo: '',
    lutExpiry: '',
    lutBondID: '',
    pan: '',
    TDSTCSNumber: '',
    entityType: '',
    cinRegNo: '',
    cinRegDate: '',
    msmeType: '',
    udhyamRegNo: '',
    username: null,
    password: '',
    ewayusername: null,
    ewaypassword: '',
    tradeLicenseNo: '',
    tradeLicNoFromDate: '',
    tradeLicNoToDate: '',
    expiresin: '',
    connect: 0,
    ewayconnect: 0,
    errorStatus: {
      registrationType: false,
      gstin: false,
      username: false,
      ewayusername: false,
      gstApplicableDate: false,
      gstReturnPeriod: false,
      ewayBillStartDate: false,
      CompositionRates: false,
      eWayBillInterStateAmount: false,
      eWayBillIntraStateAmount: false,
      eInvoiceStartDate: false,
      lutValidFrom: false,
      lutValidTo: false,
      lutExpiry: false,
      pan: false,
      TDSTCSNumber: false,
      entityType: false,
      cinRegNo: false,
      cinRegDate: false,
      msmeType: false,
      udhyamRegNo: false,
      tradeLicenseNo: false,
      tradeLicNoFromDate: false,
      tradeLicNoToDate: false,
      expiresin: false,
    },
    errorFields: {
      registrationType: '',
      gstin: '',
      username: '',
      ewayusername: '',
      gstApplicableDate: '',
      gstReturnPeriod: '',
      ewayBillStartDate: '',
      CompositionRates: '',
      eWayBillInterStateAmount: '',
      eWayBillIntraStateAmount: '',
      eInvoiceStartDate: '',
      lutValidFrom: '',
      lutValidTo: '',
      lutExpiry: '',
      pan: '',
      TDSTCSNumber: '',
      entityType: '',
      cinRegNo: '',
      cinRegDate: '',
      msmeType: '',
      udhyamRegNo: '',
      tradeLicenseNo: '',
      tradeLicNoFromDate: '',
      tradeLicNoToDate: '',
      expiresin: '',
    },
  },
};
